import React, { useState, useRef, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import nonotification_img from "../assets/home/nonotification_img.png";

const NoNotification = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  

  return (
    <>
      <div className="container-fluid bg clearall">
        <div className="Notification_sec">
          <img className="no_img" src={nonotification_img} />
          <h3>{t("nonotifiction.titel")}</h3>
          <h5> {t("nonotifiction.para")}</h5>
          


        </div>

       
      </div>

    </>
  );
};



export default NoNotification;
